var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIngIcon3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1248",
    "data-name": "\\uD0C0\\uC6D0 1248",
    cx: 23,
    cy: 23,
    r: 23,
    transform: "translate(0 0.001)",
    fill: "#316bb9"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ingIcon3",
    transform: "translate(-993 -317)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_6193",
    "data-name": "\\uC0AC\\uAC01\\uD615 6193",
    width: 90,
    height: 90,
    rx: 45,
    transform: "translate(993 317)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ing3",
    transform: "translate(1015 338.999)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1247",
    "data-name": "\\uD0C0\\uC6D0 1247",
    cx: 23,
    cy: 23,
    r: 23,
    transform: "translate(0 0.001)",
    fill: "#3363a1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uB9C8\\uC2A4\\uD06C_\\uADF8\\uB8F9_111",
    "data-name": "\\uB9C8\\uC2A4\\uD06C \\uADF8\\uB8F9 111",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34157",
    "data-name": "\\uD328\\uC2A4 34157",
    d: "M188.8,168.464l13.019,13.019a19.317,19.317,0,0,0,14.33-18.659v-.549L205.264,152Z",
    transform: "translate(-170.008 -135.977)",
    fill: "#282828",
    opacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_59268",
    "data-name": "\\uADF8\\uB8F9 59268",
    transform: "translate(10.896 13.98)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34158",
    "data-name": "\\uD328\\uC2A4 34158",
    d: "M98.524,208.045a2.283,2.283,0,0,1,0,3.171l-1.768,1.768a2.283,2.283,0,0,1-3.171,0l-7.744-7.805a2.283,2.283,0,0,1,0-3.171l1.768-1.768a2.283,2.283,0,0,1,3.171,0Z",
    transform: "translate(-85.2 -193.929)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34159",
    "data-name": "\\uD328\\uC2A4 34159",
    d: "M178.455,125.84a2.283,2.283,0,0,1,3.171,0l1.768,1.768a2.283,2.283,0,0,1,0,3.171l-13.415,13.354a2.283,2.283,0,0,1-3.171,0l-1.768-1.768a2.283,2.283,0,0,1,0-3.171Z",
    transform: "translate(-158.363 -125.2)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIngIcon3);
export default __webpack_public_path__ + "static/media/ingIcon3.640df3eef4be731a023db533a2e3f68c.svg";
export { ForwardRef as ReactComponent };